/* Plier store: gallery, tier selector, sticky add to cart, delivery date, one-line headings. No dependencies. */
(function () {
  if (window.__plInit) return;
  window.__plInit = true;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function gallery(g) {
    var t = $('.pl-gal__track', g), dots = $$('[data-pl-dot]', g), thumbs = $$('[data-pl-thumb]', g), raf = 0;
    if (!t) return;
    function go(i) { t.scrollTo({ left: t.clientWidth * i, behavior: 'smooth' }); }
    dots.concat(thumbs).forEach(function (b) { b.addEventListener('click', function () { go(+b.getAttribute('data-i')); }); });
    t.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var i = Math.round(t.scrollLeft / Math.max(1, t.clientWidth));
        dots.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
        thumbs.forEach(function (d, k) { d.classList.toggle('is-on', k === i); });
      });
    }, { passive: true });
  }

  function buyBox(box) {
    var radios = $$('input[name="id"]', box);
    var now = $('[data-pl-now]', box), was = $('[data-pl-was]', box), save = $('[data-pl-save]', box), note = $('[data-pl-note]', box);
    var st = document.querySelector('[data-pl-sticky="' + box.getAttribute('data-pl-buy') + '"]');
    function upd() {
      var r = radios.filter(function (x) { return x.checked; })[0];
      if (!r) return;
      radios.forEach(function (x) { var l = x.closest('.pl-tier'); if (l) l.classList.toggle('is-on', x === r); });
      var d = r.dataset;
      if (now) now.textContent = d.price;
      if (was) { was.textContent = d.was || ''; was.hidden = !d.was; }
      if (save) { save.textContent = d.save || ''; save.hidden = !d.save; }
      if (note) { note.textContent = d.note || ''; note.parentNode.style.visibility = d.note ? '' : 'hidden'; }
      if (st) {
        var tt = $('[data-pl-st-t]', st), pp = $('[data-pl-st-p]', st);
        if (tt) tt.textContent = d.title;
        if (pp) pp.textContent = d.price;
      }
      box.dispatchEvent(new CustomEvent('pl:variant', { bubbles: true, detail: { id: r.value } }));
    }
    radios.forEach(function (r) { r.addEventListener('change', upd); });
    upd();
    var atc = $('.pl-atc', box);
    if (st && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var e = es[0];
        st.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(atc);
    }
    var dl = $('[data-pl-date]', box);
    if (dl) {
      var n = parseInt(dl.getAttribute('data-days'), 10) || 10, dt = new Date();
      while (n > 0) { dt.setDate(dt.getDate() + 1); var w = dt.getDay(); if (w !== 0 && w !== 6) n--; }
      dl.textContent = dt.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }
  }

  function fit() {
    $$('[data-pl-fit]').forEach(function (h) {
      h.style.fontSize = '';
      var fs = parseFloat(getComputedStyle(h).fontSize), min = 15;
      var guard = 40;
      while (h.scrollWidth > h.clientWidth + 0.5 && fs > min && guard--) { fs -= 1; h.style.fontSize = fs + 'px'; }
    });
  }

  function init() {
    $$('[data-pl-gal]').forEach(gallery);
    $$('[data-pl-buy]').forEach(buyBox);
    $$('a[href="#buy"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var t = document.getElementById('buy');
        if (!t) return;
        e.preventDefault();
        t.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    var rt = 0;
    window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(fit, 120); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
